import { isPlainArrayField } from '../../../../datatype/Datatype';
import { createConditionOperator } from '../../IConditionOperator';

export const ConditionOperatorContainsNoOne = createConditionOperator({
  code: 'containsNoOne',
  label: 'non contiene',
  description: 'Non contiene nessuno dei seguenti elementi',
  args: [
    {
      type: 'referenceValue',
      isArray: true,
    },
  ],
  allowsField: field => isPlainArrayField(field),
  compare(value: any, [items]: readonly [any[]]) {
    if (!Array.isArray(value) || !items) {
      return false;
    }

    return !value.some(item => items.includes(item));
  },
});
